export default __webpack_public_path__ + "locales/sr-Latn-RS/Ldap.json?hash=27451074c46f3c69d3d1ca8c11750a82";